import type { ReactNode } from 'react'
import styles from './DisposicionNavegacion.module.css'

/** Distribuye navegación principal y auxiliar sin conocer rutas ni permisos. */
export function DisposicionNavegacion({
  principal,
  auxiliar,
}: {
  principal: ReactNode
  auxiliar?: ReactNode
}) {
  return (
    <div className={styles.root}>
      <div className={styles.principal} data-navigation-region="principal">{principal}</div>
      {auxiliar ? (
        <div className={styles.auxiliar} data-navigation-region="auxiliar">{auxiliar}</div>
      ) : null}
    </div>
  )
}
